import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { marginBottomLevels } from '@piggybank/core';
import isEmpty from 'lodash/fp/isEmpty';
import { connect, Field as Field$1 } from 'formik';
import FieldProvider from './FieldProvider.js';
import FormikAdapter from './FormikAdapter.js';
var Field = connect(function (_ref) {
  var name = _ref.name,
      formik = _ref.formik,
      onChange = _ref.onChange,
      debounceWait = _ref.debounceWait,
      invalidateNestedFields = _ref.invalidateNestedFields,
      rest = _objectWithoutProperties(_ref, ["name", "formik", "onChange", "debounceWait", "invalidateNestedFields"]);

  return isEmpty(formik) || !name ? React.createElement(FieldProvider, _extends({
    name: name,
    onChange: onChange || function () {}
  }, rest)) : React.createElement(Field$1, {
    name: name
  }, function (fieldProps) {
    return React.createElement(FormikAdapter, _extends({
      onChange: onChange,
      debounceWait: debounceWait,
      invalidateNestedFields: invalidateNestedFields
    }, fieldProps, rest));
  });
});
Field.displayName = 'Field';
Field.propTypes = process.env.NODE_ENV !== "production" ? {
  /** docgen-from-context:<Form/> */
  debounceWait: PropTypes.number,

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels),
  name: PropTypes.string.isRequired,

  /** docgen-from-context:<Form/> */
  value: PropTypes.any,

  /** docgen-from-context:<Form/> */
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),

  /** docgen-from-context:<Form/> */
  touched: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),

  /** docgen-from-context:<Form/> */
  invalid: PropTypes.bool,

  /** docgen-from-context:<Form/> */
  onChange: PropTypes.func,

  /** docgen-from-context:<Form/> */
  onBlur: PropTypes.func,

  /** docgen-from-context:<Form/> */
  required: PropTypes.bool,
  children: PropTypes.node
} : {};
Field.defaultProps = {
  marginBottom: 5
};
export default Field;
export { Field };